<template>
  <div class="corporateTravelPage">
    <div class="banner">
      <img src="../assets/CorporateTravel/banner02.png" alt="">
    </div>
    <div class="serviceStandards first">
      <h2>“商旅节省六式”服务准则</h2>
      <div class="english">— SERVICE CRITERIA —</div>
      <div class="imgList clearfix">
        <img src="../assets/CorporateTravel/1.png" alt="">
        <img src="../assets/CorporateTravel/2.png" alt="">
        <img src="../assets/CorporateTravel/3.png" alt="">
      </div>
      <div class="trait">
        <div class="traitContent">
           省钱
        <i class="symbol">/</i>省时
        <i class="symbol">/</i>省心
        </div>
      </div>
      <div class="describe">
        <p><strong>一式：</strong><span>省钱 商旅优惠价成本<i>节省可达30%</i>，降低企业成本方能实现价值。</span></p>
        <p class="spe"><strong>二式：</strong><span>省钱 <i>30+15</i>结算周期，节省企业现金流成本，减轻企业压力。</span></p>
        <p><strong>三式：</strong><span>省时 <i>60秒</i>迅速响应客户需求，您的时间更为宝贵。</span></p>
        <p class="spe"><strong>四式：</strong><span>省时 <i>7*24*365</i>不间断服务，商旅顾问时刻在您身边。</span></p>
        <p><strong>五式：</strong><span>省心 有温度的管家式<i>1对1定制</i>服务，您的出行是我们的责任。</span></p>
        <p><strong>六式：</strong><span>省心 企业OA<i>系统对接</i>，结算<i>一站式搞定</i>，商旅其实可以很轻松。</span></p>
      </div>
    </div>

    <div class="intelligentSystem">
      <h2>智能化差旅系统</h2>
      <div class="english">— INTELLIGENT TRAVEL SYSTEM —</div>
      <div class="intelligentSystemC">
        <p>智能化差旅系统，导入企业差旅政策，提供消费权限、审核审批、财报分析等功能 实现企业差旅管理的全流程管控，并最终达到控制成本与提高差旅政策合规性的目的</p>
        <img src="../assets/CorporateTravel/system.png" alt="">
      </div>
    </div>
    <div class="functionSet">
      <h2>差旅管理系统功能设置</h2>
      <div class="english">— TRAVEL MANAGEMENT FUNCTION SETTINGS —</div>
      <div class="functionSetC">
        <ul class="clearfix">
        	<li v-for="(list,index) in functionSetList" :key="index">
            <img :src="list.imgUrl" alt="">
            <div class="functionName">{{list.name}}</div>
            <div class="functionDescribe" v-html="list.des">{{list.des}}</div>

          </li>
        </ul>
      </div>
    </div>

    <div class="customization">
      <h2>定制化差旅服务</h2>
      <div class="english">— CUSTOMIZED TRAVEL SERVICE —</div>
      <div class="customizationC">
        <p class="customizationDescribe">定制化差旅服务，为企业配备专属服务小组 帮助企业解决一系列差旅过程中遇到的难题</p>
        <div class="serviceBoxs clearfix">
          <div class="serviceStyleDescribe clearfix">
             <div class="serviceStyle">
               <h3>服务方式</h3>
               <p>电话服务热线</p>
               <p>微信/QQ即时沟通工具</p>
               <p>电子邮件沟通</p>
             </div>
             <div class="serviceDescribe">
               <h3>服务特点</h3>
               <p>专业性</p>
               <p>定制化</p>
               <p>全流程</p>
             </div>
          </div>
          <div class="serviceList">
            <ul class="clearfix">
            	<li>
                <img src="../assets/CorporateTravel/s1.png" alt="">
                <p>差旅服务小组</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s2.png" alt="">
                <p>客户经理一对一服务</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s3.png" alt="">
                <p>7×24小时在线服务</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s4.png" alt="">
                <p>国际差旅多语言服务</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s5.png" alt="">
                <p>60秒迅速响应</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s6.png" alt="">
                <p>机场柜台VIP服务</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s7.png" alt="">
                <p>紧急行程最佳解决方案</p>
              </li>
              <li>
                <img src="../assets/CorporateTravel/s8.png" alt="">
                <p>定期提供差旅报告</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CorporateTravel',
  data() {
    return {
      functionSetList:[
        {
          imgUrl:require('../assets/CorporateTravel/function1.png'),
          name:'权限设置',
          des:'导入差旅政策</br>管控员工支出'
        },
        {
          imgUrl:require('../assets/CorporateTravel/function2.png'),
          name:'费用审批',
          des:'精准把控每笔支出费用'
        },
        {
          imgUrl:require('../assets/CorporateTravel/function3.png'),
          name:'消息提醒',
          des:'提供预订</br>乘机等消息提醒'
        },
        {
          imgUrl:require('../assets/CorporateTravel/function4.png'),
          name:'报表分析',
          des:'多维度报表分析</br>节省一目了然'
        }
      ]
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
@import '../css/CorporateTravel.less';
</style>



// WEBPACK FOOTER //
// src/pages/CorporateTravel.vue